/** 조절기 사양 제목 순서 (등록·수정 시 인덱스별 라벨, 기본 사양) */
export const ADJUSTER_SPEC_TITLES = [
    '건설사',
    '발주일',
    '출고일',
    '발주처',
    'PCB ver.',
    'Micom ver.',
    '냉.난방',
    'LCD',
    'LCD타입',
    '사출',
    '플레이트',
    '터치IC',
    '터치가스켓',
    '환기',
    '에어컨',
    '커넥터',
    '전열교환',
    '자연외기',
    '공기청정',
    '미세먼지',
    'CO2',
    'VOC',
    '온도센서',
    '브라켓',
    '보양커버',
];

/** 제어기 사양 제목 순서 (등록·수정 시 인덱스별 라벨) */
export const CONTROLLER_SPEC_TITLES = [
    '세대수',
    '건설사',
    '발주일',
    '출고일',
    '발주처',
    'PCB ver.',
    'Micon ver.',
    'TRANS/SMPS',
    '홈넷',
    '에어컨',
    '조절기',
    '보일러',
    'AUX1',
    'AUX2',
    '데이터 정유량',
    '누수감지',
    '키태그 연동',
    '테스콘 연동',
    '서브연동',
    '서서브연동',
    '스위치 타입',
    'AC코드 타입',
    '핀 설정(D-SW)',
];

/** 조절기: 기본 사양 칸 수 */
export const ADJUSTER_INITIAL_SPEC_ROWS = ADJUSTER_SPEC_TITLES.length;

/** 제어기: 제품 등록 기본 23칸(요청 사양) */
export const CONTROLLER_INITIAL_SPEC_ROWS = 23;

export const toSpecTitleByType = (type, index) => {
    if (type === 'controller') {
        return CONTROLLER_SPEC_TITLES[index] || `사양${index + 1}`;
    }
    return ADJUSTER_SPEC_TITLES[index] || `사양${index + 1}`;
};

/** 제품등록·리스트 수정과 동일한 사양 항목(이미지/펌웨어/결선도/비고 제외) — 드롭다운 관리 선택용 */
export const ALL_KNOWN_TEXT_SPEC_TITLES = Array.from(
    new Set([...ADJUSTER_SPEC_TITLES, ...CONTROLLER_SPEC_TITLES])
).sort((a, b) => a.localeCompare(b, 'ko'));
